export function getBinarySearchAnimations(array,item){
    const animations = [];
    binarySearchHelper(array,item,animations);
    return animations;
}
function binarySearchHelper(array,item,animations){
    let l = 0;
    let r = array.length-1;
    while(l<=r){
        const mid = Math.ceil((l+r)/2);
        animations.push([1,mid]);
        animations.push([1,mid]);
        if(array[mid] === item){
            animations.push([1,mid]);
            return;
        }
        if(array[mid]<item){
            l = mid+1;
            animations.push([2,l,r]);
        }
        else{
            r = mid-1;
            animations.push([2,l,r]);
        }
    }
    
}